<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ชื่อสินค้า:</label> 
                 
                <select2
                            id="odMaterialCode"
                            name="odMaterialCode"
                            class="form-control m-select2"
                            style="width: 100%;"
                            :select2-options="odMaterialCodeOptions"
                            v-model="odMaterialCode"
                            ref="odMaterialCodeSelect2"
                            @selectChange="onMaterialCodeChange"
                          ></select2>
                          <span class="form-text"></span>
              </div>
            </div>
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6"></div> -->

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">ประเภทของการกระจายสินค้า:</label>
                <select2
                      id="odTranTypeCode"
                      name="odTranTypeCode"
                      class="form-control m-select2"
                      style="width: 100%;"
                      :select2-options="odTranTypeCodeOptions"
                      v-model="odTranTypeCode"
                      ref="odTranTypeCodeSelect2"
                      @selectChange="odTranTypeCodeChange"
                    ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">จำนวนวันแจ้งเตือนก่อนครบกำหนด:</label>
                <input
                            id="odDayBeforeAlert"
                            name="odDayBeforeAlert"
                            v-model="odDayBeforeAlert"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="จำนวนวัน"
                          />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">จำนวนวันครบกำหนด:</label>
                <input
                            id="odDayAlert"
                            name="odDayAlert"
                            v-model="odDayAlert"
                            type="number"
                            min="0"
                            class="form-control"
                            placeholder="จำนวนวัน"
                          />
              </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">วันที่มีผล:</label>
                <div class="input-group date">
                      <input
                        readonly
                        type="text"
                        class="form-control"
                        placeholder="(วว/ดด/ปปปป)"
                        id="odEffectiveDate"
                        name="odEffectiveDate"
                        ref="odEffectiveDate" 
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <i class="la la-calendar-check-o"></i>
                        </span>
                      </div>
                      <span class="form-text"></span>
                    </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label-required">วันที่มีผลย้อนหลัง:</label>
                 
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6"></div> -->

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div class="form-group">
                <label class="label">จำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ):</label>
                <input
                            id="odRentalPrice"
                            name="odRentalPrice"
                            v-model="odRentalPrice"
                            type="number" min="0.00"  
                            class="form-control"
                            placeholder="จำนวนเงินค่าเช่า(บาท)"
                          /> 
              </div>
            </div>
          </div>

          <!-- Begin:InActiveStatus element -->
          <div class="row">
            <div class="col-xl-2">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input
                      id="odInActiveStatus"
                      name="odInActiveStatus"
                      v-model="odInActiveStatus"
                      type="checkbox"
                      class="form-check-input"
                    />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- End:InActiveStatus element -->
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import datepicker from "../../../Shared/Datepicker";

import plupload from "plupload"; 

export default {
  components: {
    select2,
    datepicker,
  }, 
  data: function() {
    var self = this;

    return {
      odMaterialName: null, 
      odMaterialCode:null,
      odTranTypeCode:null,
      odDayBeforeAlert:null,
      odEffectiveDate:null,
      odRentalPrice : null,
      odInActiveStatus : true,
      odTranTypeName : null,
      odDayAlert : null,
      
      odTranTypeCodeOptions:[], 
      odMaterialCodeOptions: [],

      odMaterialCodeOptions: {
        placeholder: "เลือกสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/Product/Select2Product",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1, 
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      odTranTypeCodeOptions: {
        placeholder: "เลือกประเภทของการกระจายสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/MasterOverdueSetting/Select2BarcodeAlertTransType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1, 
              onlyHasBarcode: true,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      } 
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      

      let router = this.$router;
      let self = this;

      axios
        .post("/Api/MasterOverdueSetting", { 

        odMaterialName: this.odMaterialName, 
        odMaterialCode:this.odMaterialCode,
        odTranTypeCode:this.odTranTypeCode,
        odDayBeforeAlert:this.odDayBeforeAlert,
        odDayAlert : this.odDayAlert ,
        odEffectiveDate:
        self.odEffectiveDate != null
                ? self.odEffectiveDate.format("DD/MM/YYYY")
                : self.odEffectiveDate, 
        odRentalPrice : this.odRentalPrice,
        odInActiveStatus : !this.odInActiveStatus,

        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onMaterialCodeChange: function(id, text, data, ref) {
      var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odMaterialName = data[0].text;
      } 
    },
    odTranTypeCodeChange: function(id, text, data, ref) {
       //nothing
       var self = this;
      //set product name
      if (data[0] && data[0].text) {
        self.odTranTypeName = data[0].text;
      } 
    },

  },
  async mounted() {
    let self = this;
    let router = this.$router; 
    let user = await this.$root.getUser();
    var arrows;
    // set validation rules
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(this.$refs.form).validate({
 
      rules: {
        odMaterialCode: "required", 
        odTranTypeCode:"required", 
        odDayBeforeAlert:"required", 
        odRentalPrice : "required",
        odDayAlert: "required",

        
      },
      messages: { 
        odMaterialCode: "กรุณาเลือกชื่อสินค้า", 
        odTranTypeCode:"กรุณาเลือกประเภทของการกระจายสินค้า", 
        odDayBeforeAlert:"กรุณากรอกจำนวนวันแจ้งเตือนก่อนครบกำหนด", 
        odRentalPrice : "กรุณากรอกจำนวนเงินค่าเช่า กรณีเกินกำหนด (วันละ)",
        odDayAlert:"กรุณากรอกจำนวนวันครบกำหนด", 
      },
    });
    $(self.$refs.odEffectiveDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      //endDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.odEffectiveDate)
      .datepicker(
        "update",
        !!self.odEffectiveDate ? self.odEffectiveDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.odEffectiveDate = e.dates.length != 0 ? moment(e.date) : null;
      });

  },
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-plant {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-plant {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1.2rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// App/Components/Master/OverdueSetting/OverdueSettingCreate.vue